export const OPERATION_LIST = [
  { title: '编辑信息', value: 0 },
  { title: '进入中控台', value: 1 },
  { title: '推广直播', value: 2 },
  { title: '删除', value: 2 }
]

export const LIVE_STATUS = [
  { title: '直播中', value: 1, color: 'primary', operation: [1, 2] },
  { title: '未开始', value: 2, color: 'warn', operation: [0, 1, 2, 3] },
  { title: '已结束', value: 3, color: 'default', operation: [1] }
]

export const VERIFY_STATUS = [
  { title: '审核中', value: 1, needReason: false, color: 'primary' },
  { title: '审核通过', value: 2, needReason: false, color: 'default' },
  { title: '审核不通过', value: 3, needReason: true, color: 'error' }
]

export const LIVE_TYPE = [
  {
    label: '营销特卖',
    value: 1
  },
  {
    label: '探店体验',
    value: 2
  },
  {
    label: '知识科普',
    value: 3
  }
]

export const LIVE_TYPE_DESC = [
  '营销特卖，包括限时优惠、店庆、砍价、节日营销、季节特惠等促销类直播；',
  '探店体验，包括探店、拍摄基地带看、婚礼现场、婚纱体验、品牌宣传类等；',
  '知识科普，包括知识传播类等。'
]
